import MMenu from "./MMenu.vue";
export default MMenu;
